import { ThemeOverride } from '@chakra-ui/react';

const tokens: ThemeOverride['semanticTokens'] = {
  colors: {
    // ── Reskin design-system tokens (Refined Indigo) — see design-guidelines.md ──
    'bg.canvas': { _light: '#f6f7f9', _dark: '#0e0f13' },
    'bg.surface': { _light: '#ffffff', _dark: '#17191f' },
    'bg.surfaceRaised': { _light: '#ffffff', _dark: '#1d2027' },
    'bg.sidebar': { _light: '#fbfbfd', _dark: '#121419' },
    'border.default': { _light: '#d0d4da', _dark: '#272b33' },
    'border.strong': { _light: '#b9bec7', _dark: '#333845' },
    'text.default': { _light: '#16181d', _dark: '#ecedf0' },
    'text.muted': { _light: '#565c66', _dark: '#9ba1ac' },
    'text.subtle': { _light: '#6b7280', _dark: '#7e8593' }, // _dark lightened to meet AA (≥4.5:1) on dark bg
    'primary.solid': { _light: '#5b5bd6', _dark: '#8b7dff' },
    'primary.hover': { _light: '#4f4fc4', _dark: '#9d90ff' },
    'primary.soft': { _light: '#ececfb', _dark: '#221f3a' },
    'primary.on': { _light: '#ffffff', _dark: '#14121f' },
    // Light values darkened to meet WCAG AA (≥4.5:1) as TEXT on their *Soft backgrounds
    // (status badges) — also raises contrast everywhere they're used as text/icons on white.
    'state.success': { _light: '#0c7a52', _dark: '#34d399' },
    'state.successSoft': { _light: '#e2f6ee', _dark: '#10241c' },
    'state.warning': { _light: '#985c00', _dark: '#fbbf24' },
    'state.warningSoft': { _light: '#fbf0dd', _dark: '#2a2008' },
    'state.error': { _light: '#c81e1e', _dark: '#f87171' },
    'state.errorSoft': { _light: '#fbe9e9', _dark: '#2a1414' },

    // ── Legacy tokens (giữ tạm cho màn chưa reskin, dọn ở cuối) ──
    bg_main_container: {
      _light: 'amatrium.700',
      _dark: 'grey.800',
    },
    bg_box: {
      _light: 'white',
      _dark: 'grey.700',
    },
    bg_main_input: {
      _light: 'white',
      _dark: 'grey.600',
    },
    bg_conversation_item: {
      _light: 'inherit',
      _dark: 'grey.700',
    },
    bg_conversation_item_select: {
      _light: 'whiteAlpha.700',
      _dark: 'grey.600',
    },
    color_main_text: {
      _light: 'grey.900',
      _dark: 'grey.50',
    },
    color_amatrium_text: {
      _light: 'amatrium.800',
      _dark: 'grey.50',
    },
    menu_item_option: {
      _light: 'white',
      _dark: 'grey.500',
    },
    menu_item_option_hover: {
      _light: 'gray.100',
      _dark: 'grey.400',
    },
    bg_icon: {
      _light: 'green.400',
      _dark: 'grey.50',
    },
  },
  shadows: {
    // ── Reskin DS shadows ──
    ds_xs: { _light: '0 1px 2px rgba(20, 24, 34, 0.05)', _dark: 'none' },
    ds_sm: {
      _light: '0 1px 3px rgba(20, 24, 34, 0.06), 0 1px 2px rgba(20, 24, 34, 0.04)',
      _dark: '0 1px 2px rgba(0, 0, 0, 0.3)',
    },
    ds_md: {
      _light: '0 4px 12px -2px rgba(20, 24, 34, 0.1), 0 2px 6px -2px rgba(20, 24, 34, 0.06)',
      _dark: '0 6px 18px -6px rgba(0, 0, 0, 0.5)',
    },
    ds_lg: {
      _light: '0 12px 32px -8px rgba(20, 24, 34, 0.16)',
      _dark: '0 18px 40px -12px rgba(0, 0, 0, 0.6)',
    },
    shadow_box: {
      _light: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      _dark: '',
    },
    outline: {
      _light: 'none',
      _dark: 'none',
    },
  },
  borders: {
    border_selected_box: {
      _light: 'none',
      _dark: 'solid white 1px',
    },
    border_dashed_box: {
      _light: 'none',
      _dark: 'dashed white 2px',
    },
    border_table_grid: {
      _light: 'solid black 1px',
      _dark: 'solid white 1px',
    },
    border_gray_solid: {
      _light: 'solid 1px #E2E8F0',
      _dark: 'none',
    },
    border_main: {
      _light: 'solid 2px #7963FF',
      _dark: 'solid 2px #ffffff',
    },
    border_main_summary: {
      _light: 'solid 2px #10a37f',
      _dark: 'solid 2px #ffffff',
    },
  },
};

export default tokens;
